import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "src/redux/store";
import Emails from "./Emails";
import "./mailbox.scss";
import {
  GetActiveMailboxProvider,
  IMailBoxSlice,
} from "src/redux/features/mailBox/mailbox-slice";
import { getTenantPlan } from "src/redux/features/plan-billing/plan-billing-slice";
import { ICurrentPlan } from "src/types/product";

const MailBox = () => {
  const dispatch = useAppDispatch();

  const { mailBoxAuthData } = useAppSelector(
    (state: { mailBoxSlice: IMailBoxSlice }) => state.mailBoxSlice
  );

  const currentPlan = useAppSelector<ICurrentPlan>(
    (state) => state.planBillingSlice.currentPlan
  );

  useEffect(() => {
    if (!mailBoxAuthData) {
      //fetch active mailbox provider
      dispatch(GetActiveMailboxProvider());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mailBoxAuthData]);

  useEffect(() => {
    dispatch(getTenantPlan());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // console.log(currentPlan,"currentPlan")

  return (
    <Box className="mailBoxContainer">
      {/* ✅ Show login button if authUrl is available */}
      {!mailBoxAuthData || !currentPlan?.addons.mailbox?.priceId ? (
        <div className="auth-msgContainer" style={{ textAlign: "left" }}>
          <Typography
            className="auth-msg"
            sx={{ fontSize: "1.1rem", textAlign: "left" }}
          >
            You are not authorized to access this mailbox module. To activate
            mailbox:
            <ol
              style={{
                margin: "20px 0",
                paddingLeft: "25px",
                lineHeight: "2",
                fontSize: "1.1rem",
                textAlign: "left",
              }}
            >
              <li style={{ textAlign: "left" }}>
                Go to{" "}
                <Link
                  to="/my-plan"
                  className="link"
                  style={{ fontWeight: 500 }}
                >
                  Billing
                </Link>{" "}
                menu to purchase the mailbox add-on.
              </li>
              <li style={{ marginTop: "15px", textAlign: "left" }}>
                Go to{" "}
                <Link
                  to="/app-integrations"
                  className="link"
                  style={{ fontWeight: 500 }}
                >
                  App Integration
                </Link>{" "}
                menu to connect your Google or Outlook email.
              </li>
            </ol>
          </Typography>
        </div>
      ) : (
        <Emails userEmail={mailBoxAuthData ? mailBoxAuthData?.email : ""} />
      )}
    </Box>
  );
};

export default MailBox;
